export default "__VITE_ASSET__By7ot_ce__"